import { defineStore } from 'pinia';
import type { appType, GetConfigFn } from '../types';
import { storageLocal, deviceDetection } from '@klondpay/utils';

// 默认配置获取函数（将在使用时被覆盖）
let getConfig: GetConfigFn = () => ({
  SidebarStatus: true,
  Layout: 'vertical',
});

/**
 * 设置配置获取函数
 */
export function setAppConfig(configFn: GetConfigFn) {
  getConfig = configFn;
}

export const useAppStore = defineStore({
  id: 'vue3-admin-app',
  state: (): appType => ({
    sidebar: {
      opened: storageLocal.getItem('responsive-layout')?.sidebarStatus ?? getConfig().SidebarStatus,
      withoutAnimation: false,
      isClickHamburger: false,
    },
    // 这里的layout用于监听容器拖拉后恢复对应的导航模式
    layout: storageLocal.getItem('responsive-layout')?.layout ?? getConfig().Layout,
    device: deviceDetection() ? 'mobile' : 'desktop',
  }),
  getters: {
    getSidebarStatus(): boolean {
      return this.sidebar.opened;
    },
    getDevice(): string {
      return this.device;
    },
  },
  actions: {
    TOGGLE_SIDEBAR(opened?: boolean, resize?: string) {
      const layout = storageLocal.getItem('responsive-layout');
      if (opened && resize) {
        this.sidebar.withoutAnimation = true;
        this.sidebar.opened = true;
        layout.sidebarStatus = true;
      } else if (!opened && resize) {
        this.sidebar.withoutAnimation = true;
        this.sidebar.opened = false;
        layout.sidebarStatus = false;
      } else if (!opened && !resize) {
        this.sidebar.withoutAnimation = false;
        this.sidebar.opened = !this.sidebar.opened;
        this.sidebar.isClickHamburger = !this.sidebar.opened;
        layout.sidebarStatus = this.sidebar.opened;
      }
      storageLocal.setItem('responsive-layout', layout);
    },
    TOGGLE_DEVICE(device: string) {
      this.device = device;
    },
    async toggleSideBar(opened?: boolean, resize?: string) {
      await this.TOGGLE_SIDEBAR(opened, resize);
    },
    toggleDevice(device: string) {
      this.TOGGLE_DEVICE(device);
    },
    setLayout(layout: string) {
      this.layout = layout;
    },
  },
});

// 导出快捷 hook
export const useAppStoreHook = () => useAppStore();

// 导出 hook 函数创建器，允许各应用传入自己的 store 实例
export function createAppStoreHook(store: any) {
  return function () {
    return useAppStore(store);
  };
}
